import React from "react";
import { SoonBadge } from "../../atoms/SoonBadge";
import type { SettingRowProps, SettingsGroupProps } from "./SettingRow.types";
import { Copy, Group, GroupBody, GroupHead, GroupTitle, Hint, Label, Row, Summary } from "./SettingRow.styles";

/** One labelled setting: label, hint, optional Coming soon tag, and a control slot. */
export const SettingRow: React.FC<SettingRowProps> = ({ label, description, children, comingSoon = false, stacked = false, className }) => (
  <Row $stacked={stacked} $dim={comingSoon} className={className}>
    <Copy>
      <Label>
        {label}
        {comingSoon ? <SoonBadge size="sm" /> : null}
      </Label>
      {description ? <Hint>{description}</Hint> : null}
    </Copy>
    {children}
  </Row>
);

/** A titled card that stacks SettingRows. */
export const SettingsGroup: React.FC<SettingsGroupProps> = ({ title, summary, children, className }) => (
  <Group className={className} aria-label={title}>
    <GroupHead>
      <GroupTitle>{title}</GroupTitle>
      {summary ? <Summary>{summary}</Summary> : null}
    </GroupHead>
    <GroupBody>{children}</GroupBody>
  </Group>
);
